module.exports = __webpack_public_path__ + "static/img/PK2.387ae62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK2.jpg
// module id = YALP
// module chunks = 0